import { useCareTeam } from './useCareTeam';
import { useEffect } from 'react';
import { gql } from '@apollo/client';
import { CaseManagerDetails } from '../../type';
import { graphql } from '@xolv-mybrightlink/common';

type CcmDetailsResponse = {
  ccmDetails: CaseManagerDetails[];
};

export const useFetchCcmDetails = () => {
  const [store, dispatch] = useCareTeam();
  const isLoading = store === 'LOADING';
  useEffect(() => {
    const fetch = async () => {
      if (isLoading) {
        return;
      }
      const query = gql`
        query caseManagerDetails {
          ccmDetails: clientCaseManagerDetailsV2 {
            sfId
            firstName
            lastName
            email
            mobilePhone
            languages
            licenses {
              licenseDetail
              licenseNumber
            }
            degrees {
              degreeDetail
              graduatedFrom
            }
            assignedPatientGuids: assignedPatientGuidList
          }
        }
      `;
      const { data } = await graphql.query<CcmDetailsResponse>({ query });
      dispatch({
        type: 'CCM_DETAILS_UPDATE',
        ccmDetails: data.ccmDetails,
      });
    };
    fetch();
  }, [isLoading, dispatch]);
};
